const bodyBuildingData = [
    {
        id: 1,
        name: "بدنسازی مبتدی",
        nameInLatin: "Fitness",
        img: "/images/weight.png",
        color: "var(--pink)",
        subset: ""
    },
    {
        id: 2,
        name: "بدنسازی متوسط",
        nameInLatin: "Fitness",
        img: "/images/weight.png",
        color: "var(--pink)",
        subset: ""
    },
    {
        id: 3,
        name: "بدنسازی پیشرفته",
        nameInLatin: "Fitness",
        img: "/images/weight.png",
        color: "var(--pink)",
        subset: ""
    }
]

export default bodyBuildingData